import {useEditableControls} from '@chakra-ui/react';
import type {ReactNode} from 'react';

export const EditableOn = (props: {children: ReactNode}) => {
  const {isEditing} = useEditableControls();

  return isEditing ? <>{props.children}</> : null;
};
